import { reportMxMAnalytics, getSessionId } from "@roc-digital/mxm-base/logic";
import { Analyticer, AnalyticerStorage, Spanner } from '@roc-digital/ui-lib';

export function reportSignupFromUtmUrl() {
  const utmUrl = localStorage.getItem('utm_url') || '';
  const utmReferrer = localStorage.getItem('utm_referrer') || '';
  const signupArticleId = localStorage.getItem('signup_article_id') || '';

  if(utmUrl || signupArticleId ) {
    reportMxMAnalytics({
      signupUtmUrl: utmUrl,
      utmReferrerUrl: utmReferrer,
      signupArticleId: signupArticleId,
    });
  
    localStorage.removeItem('utm_url');
    localStorage.removeItem('utm_referrer');
    localStorage.removeItem('signup_article_id');
  }
}

export function logUtmParameter() {
  const search = window.location.search;
  if(search.includes("?utm") || search.includes("&utm")) {
    localStorage.setItem('utm_url', window.location.toString());
    localStorage.setItem('utm_referrer', document.referrer || '');
  }
}

export function logSignupArticleId(articleId: string) {
  localStorage.setItem('signup_article_id', articleId || '');
}

let analyticer: Analyticer;

export function setAnalyticsUserId(userId: string) {
  if (analyticer) {
    localStorage.setItem('a.uid', userId || '');
    analyticer.setUser(userId)
  };
}

export function initAnalytics(baseApiUrl: string) {
  try {
    let sessionId = window.localStorage.getItem('a.sid');
    if(!sessionId) {
      sessionId = crypto.randomUUID();
      window.localStorage.setItem('a.sid', sessionId)
    }
    
    const sender = createDataSender(baseApiUrl);
    const spanner = new Spanner(
    sessionId,
    'web',
    (span) => {
      sender({
        ...span,
        t: 'span',
      });
    },
    (event) => {
      sender({
        ...event,
        t: 'event',
      });
    },
    () => crypto.randomUUID()
  )

    analyticer = new Analyticer(spanner, localStorage, () => {
      const attributes: any =  {
        http_url: window.location.toString()
      }
  
      if(window.navigator.userAgent) {
        attributes['http_agent'] = window.navigator.userAgent;
      }

      return attributes;
    });
  
    const userId = window.localStorage.getItem('a.uid');
    if(userId) {
      analyticer.setUser(userId);
    }
  
    //@ts-ignore
    window.navigation.addEventListener("navigate", () => {
      setTimeout(reportPageVisit, 100);
    });

    analyticer.start();

    reportPageVisit();

    window.addEventListener('beforeunload', () => {
      analyticer.end();
    })
  } catch(err) {
    console.error(err);
  }
}



export function reportPageVisit() {
  if(!analyticer) return;
  const pathname = window.location.pathname;
  const parts = pathname.split('/').filter(a => a);

  if(parts[0] === 'article' || parts[0] === 'articles') {
    analyticer.setLastVisitedArticle(parts[1])
    analyticer.visit('article', {articleId: parts[1]})
  } else {
    const label = parts.join('_');
    analyticer.visit(label, {})
  }
}

export function logEvent(event: string, attributes: {[key: string]: string}) {
  if(!analyticer) return;
  analyticer.event(event, attributes);
}

let authToken = '';

export function setAnalyticsAuthHeader(token: string) {
  authToken = token;
}

function createDataSender(baseUrl: string) {
  const url = baseUrl + '/analytics';
  const noBeacon = true

  //@ts-ignore
  if(navigator?.sendBeacon && noBeacon !== true) {
    return (span: any) => {
      const headers = {
        type: 'application/json',
      };
      span = {
        ...span,
        sessionId: getSessionId(),
      };
      const blob = new Blob([JSON.stringify(span)], headers);
      const result = navigator.sendBeacon(url, blob);
      console.log('Send Data', url, result, span);
    }
  } else {
    return  (span: any) => {
      const headers: any = {
        'Content-Type': 'application/json',
      };

      if(authToken) {
        headers['Authorization'] = `Bearer ${authToken}`;
      }
      span = {
        ...span,
        sessionId: getSessionId(),
      };

      fetch(url, {
        method: 'POST',
        body: JSON.stringify(span),
        keepalive: true,
        headers,
      }).catch(e => console.error(e));
    }
  }

}
